const langConfig = {
	"zh-cn": "中文",
	"en": "EN"
}

let levelList = [100, 500, 2000, 10000, 30000, 50000, 100000, 300000, 500000, 1000000];
let levelRewardConfig = {
	l1: {
		usdt: 1,
		token: 1000
	},
	l2: {
		usdt: 5,
		token: 10000
	},
	l3: {
		usdt: 20,
		token: 20000
	},
	l4: {
		usdt: 100,
		token: 100000
	},
	l5: {
		usdt: 200,
		token: 200000
	},
	l6: {
		usdt: 300,
		token: 500000
	},
	l7: {
		usdt: 500,
		token: 1000000
	},
	l8: {
		usdt: 2000,
		token: 3000000
	},
	l9: {
		usdt: 2000,
		token: 5000000
	},
	l10: {
		usdt: 10000,
		token: 10000000
	}
}

const chainConfig = {
	1: {
		chainId: '0x1',
		chainName: 'Ethereum Mainnet',
		nativeCurrency: {
			name: 'ETH',
			symbol: 'ETH',
			decimals: 18,
		},
		rpcUrls: ['https:///v3/9aa3d95b3bc440fa88ea12eaa4456161'],
		blockExplorerUrls: ['https://'],
	},
	100: { //xdai
		chainId: '0x64',
		chainName: 'Gnosis Chain',
		nativeCurrency: {
			name: 'xDai',
			symbol: 'xDai',
			decimals: 18,
		},
		rpcUrls: ['https://rpc.gnosischain.com'],
		blockExplorerUrls: ['https://gnosisscan.io'],
	},
	"0xa4b1": { //arb
		chainId: '0xa4b1',
		chainName: 'Arbitrum One',
		nativeCurrency: {
			name: 'ETH',
			symbol: 'ETH',
			decimals: 18,
		},
		rpcUrls: ['https://arb1.arbitrum.io/rpc'],
		blockExplorerUrls: ['https://arbiscan.io/'],
	},
	"0x2105":{
		chainId: '0x2105',
		chainName: 'Base Mainnet',
		nativeCurrency: {
			name: 'ETH',
			symbol: 'ETH',
			decimals: 18,
		},
		rpcUrls: ['https://base-mainnet.infura.io'],
		blockExplorerUrls: ['https://basescan.org/'],
	}
}
export default {
	DEFAULT_CHAINID: '0x2105',
	chainConfig,
	baseFee: 0.0004,
	fireInterval: 4 * 3600 * 1000,
	maxFireCount: 2,
	levelList,
	levelRewardConfig,
	VUE_APP_TOKEN: "0x0d906D1c787D67CA0890766F8D5A97351D3E49b9",
	VUE_USDT_TOKEN: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
	VUE_MAIN_CONTRACT: "0xfE0a625E93fa3BD414067fAF5515e1B1304876f6",
    VUE_STORAGE_CONTRACT: "0xdb284601baeaA6260B6dD7Df9E9E6c35BDDcB920",
	ADMIN_ADDRESS: "",
	defaultLang: "en",
	langConfig: langConfig
}